import { useTranslation } from "react-i18next"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"
import { AttachmentType } from "shared/types/__generated__/graphql"
import { FileUpload } from "shared/ui/file-upload/FileUpload"

interface XlsxFileUploadProps {
  xlsxFile?: AttachmentType
  onXlsxUpload?: (file: FilePreview) => Promise<ApiResponse<unknown>>
  onXlsxUploadComplete: (
    successes: FilePreview[],
    failures: FilePreview[]
  ) => void
  onXlsxDelete: () => void
  isDisabled?: boolean
  hintId?: string
}

const xlsxAccept = {
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]
}

export function XlsxFileUpload({
  xlsxFile,
  onXlsxUpload,
  onXlsxUploadComplete,
  onXlsxDelete,
  isDisabled,
  hintId
}: XlsxFileUploadProps) {
  const { t } = useTranslation()

  return (
    <div aria-describedby={hintId}>
      <FileUpload.Root
        className="new-project-overlay__xlsx-file-upload"
        multiple={false}
        files={xlsxFile}
        onUpload={xlsxFile ? undefined : onXlsxUpload}
        onUploadComplete={onXlsxUploadComplete}
        onDelete={onXlsxDelete}
        label={t("NewProjectOverlay.XlsxUpload.Label")}
        accept={xlsxAccept}
        isDisabled={isDisabled}
      >
        <FileUpload.Label />
        <FileUpload.List />
        <FileUpload.Input hideDuringUpload variant="minimal" />
      </FileUpload.Root>
    </div>
  )
}
